import React, { createContext, useState, useContext, useEffect } from 'react';
import api from '../services/api';

const AuthContext = createContext();

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  async function checkAuth() {
    try {
      const data = await api.getCurrentUser();
      setUser(data.user);
    } catch {
      // Kein gültiges Cookie → nicht eingeloggt
    }
    setLoading(false);
  }

  async function login(username, password) {
    const data = await api.login(username, password);
    // Bei 2FA: kein user-Cookie gesetzt → data.requires_2fa = true
    if (data.requires_2fa) return data;
    setUser(data.user);
    return data;
  }

  async function loginWith2fa(temp_token, code) {
    const data = await api.totp2faLogin(temp_token, code);
    setUser(data.user);
    return data;
  }

  async function logout() {
    await api.logout();
    setUser(null);
  }

  const value = {
    user,
    loading,
    login,
    loginWith2fa,
    logout,
  };

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontFamily: 'var(--font-display)',
        fontSize: '1.5rem',
        color: 'var(--color-text-muted)'
      }}>
        Lade...
      </div>
    );
  }

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}
